// Throttle function to limit how often the observer callback runs
function throttle(callback, limit) {
    let wait = false;
    return function(...args) {
        if (!wait) {
            callback.apply(this, args);
            wait = true;
            setTimeout(() => {
                wait = false;
            }, limit);
        }
    };
}

// Create a single IntersectionObserver instance
const observer = new IntersectionObserver(
    throttle((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('-detected');  // Add the '-active' class when the element is in view
                observer.unobserve(entry.target);  // Stop observing once the element has been activated
            }
        });
    }, 500),  // Throttle the callback to fire at most once every 500ms
    {
        rootMargin: '0px 0px -100px 0px',
        threshold: 0.1  // Trigger when 10% of the element is visible
    }
);

// Initialize test function to observe elements
export function initObserver() {
    return [...document.querySelectorAll('.-observe:not(.initialized)')].map(el => {
        el.classList.add('-initialized');
        observer.observe(el);  // Observe each element for visibility
    });
}

//there is a mixin called @mixin observe-animation
//this mixin is used to animate elements when they come into view
//usage
// .b-block__element {
//     @include observe-animation
// }
// the class -observe can be added on a block as default or in backend on the section

